import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6ee31547&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6ee31547&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee31547",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ee31547')) {
      api.createRecord('6ee31547', component.options)
    } else {
      api.reload('6ee31547', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6ee31547&scoped=true", function () {
      api.rerender('6ee31547', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/coupon/list/modules/Detail/index.vue"
export default component.exports